import { render, staticRenderFns } from "./SlotMachine.vue?vue&type=template&id=f25df906&scoped=true&"
import script from "./SlotMachine.vue?vue&type=script&lang=js&"
export * from "./SlotMachine.vue?vue&type=script&lang=js&"
import style0 from "./SlotMachine.vue?vue&type=style&index=0&id=f25df906&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25df906",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
